import {
  AI_BILLING_BALANCE_ENDPOINT,
  AI_CONVERSATIONS_ENDPOINT,
} from '../constants/aiAgents'
import { EMPTY_OBJECT } from '../constants/common'
import { deleteApi, getApi, patchApi, postApi, putApi } from '../utils/api'

export function getSummaryTaskStatus({ id, params }) {
  return getApi({
    endpoint: `api/ai-agents/summary-task/${id}/`,
    params,
  })
}

export function getEmailThreadSummary({ params, uuid }) {
  return getApi({
    endpoint: `api/ai-agents/thread-summary/${uuid}/`,
    params,
  })
}

export function getEmailMessageSummary({ params, uuid }) {
  return getApi({
    endpoint: `api/ai-agents/email-message-summary/${uuid}/`,
    params,
  })
}

export function getRequestSummaryTaskStatus({ id, params }) {
  return getApi({
    endpoint: `api/ai-agents/request-summary/task/${id}/`,
    params,
  })
}

export function getRequestSummary({ id, options, params }) {
  return getApi({
    endpoint: `api/ai-agents/request-summary/${id}/`,
    options,
    params,
  })
}

export function generateRequestSummary(data) {
  return postApi({
    data,
    endpoint: 'api/ai-agents/request-summary/generate/',
  })
}

export function generateEmailThreadSummary(data) {
  return postApi({
    data,
    endpoint: 'api/ai-agents/thread-summary/generate/',
  })
}

export function generateEmailMessageSummary(data) {
  return postApi({
    data,
    endpoint: 'api/ai-agents/email-message-summary/generate/',
  })
}

export function getAIEmailPrompts({ options } = EMPTY_OBJECT) {
  return getApi({ endpoint: 'api/ai-agents/email/prompts/', options })
}

export function generateAIText({ data, options }) {
  return postApi({
    data,
    endpoint: 'api/ai-agents/text/generate/',
    options,
  })
}

export function generateWorkflowBotWizard(data) {
  return postApi({
    data,
    endpoint: 'api/ai-agents/workflow-bot-wizard/generate/',
  })
}

export function suggestAttachServiceRequests(data) {
  return postApi({
    data,
    endpoint: 'api/ai-agents/request-suggester/suggest/',
  })
}

export function getAIBillingBalance({ options } = EMPTY_OBJECT) {
  return getApi({ endpoint: AI_BILLING_BALANCE_ENDPOINT, options })
}

export function getAIConversations({ options, params } = EMPTY_OBJECT) {
  return getApi({ endpoint: AI_CONVERSATIONS_ENDPOINT, options, params })
}

export function getAIConversation({ id, options, params }) {
  return getApi({
    endpoint: `${AI_CONVERSATIONS_ENDPOINT}${id}/`,
    options,
    params,
  })
}

export function createAIConversation({ data, options }) {
  return postApi({ data, endpoint: AI_CONVERSATIONS_ENDPOINT, options })
}

export function updateAIConversation({ data, id, options }) {
  return patchApi({
    data,
    endpoint: `${AI_CONVERSATIONS_ENDPOINT}${id}/`,
    options,
  })
}

export function deleteAIConversation({ id, options }) {
  return deleteApi({ endpoint: `${AI_CONVERSATIONS_ENDPOINT}${id}/`, options })
}

export function searchAIConversations({ options, params }) {
  return getApi({
    endpoint: `${AI_CONVERSATIONS_ENDPOINT}search/`,
    options,
    params,
  })
}

export function getAIConversationMessages({ id, options, params }) {
  return getApi({
    endpoint: `${AI_CONVERSATIONS_ENDPOINT}${id}/messages/`,
    options,
    params,
  })
}

export function getAIConversationPendingAnswers({ id, options }) {
  return getApi({
    endpoint: `${AI_CONVERSATIONS_ENDPOINT}${id}/pending-answers/`,
    options,
  })
}

export function submitAIConversationMessageFeedback({
  conversationId,
  data,
  messageId,
  options,
}) {
  return putApi({
    data,
    endpoint: `${AI_CONVERSATIONS_ENDPOINT}${conversationId}/messages/${messageId}/feedback/`,
    options,
  })
}
